import { render, staticRenderFns } from "./BlocsRecapitulatifs.vue?vue&type=template&id=89648854&scoped=true&"
import script from "./BlocsRecapitulatifs.vue?vue&type=script&lang=js&"
export * from "./BlocsRecapitulatifs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89648854",
  null
  
)

export default component.exports